import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const ConfigurePaymentGateways = lazy(
  () => import('../../pages/ConfigurePaymentGateways/ConfigurePaymentGatewaysPage'),
);

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<ConfigurePaymentGateways />} />
    </Routes>
  );
}

export default PagesRoute;
